<FluidForm>
	<Grid>

		<Row padding>
			<Column xlg={4}>

			<p>BIOMARKER CODES</p>
			<h1>Client Login</h1>
			<p style="visibility:hidden;">BIOMARKER CODES</p>

			<TextInput 
				type="email" 
				id="inputEmail" 
				placeholder="Email address" 
				skeleton={skelliButton}
				value={email}
				on:input={event => (email = event.target.value)}
				required
			/>
			
			<PasswordInput 
				id="password" 
				placeholder="Password" 
				skeleton={skelliButton}
				value={password}
				on:input={event => (password = event.target.value)}						 
				required
			/>
		</Column>
		</Row>

		<Row>
			<Column xlg={4} >
            <Link
							class="float-right"
              inline
              href={`/auth/forgot`}
            >
              Forgot password?
            </Link>
			</Column>
		</Row>

		<Row padding>
			<Column xlg={4}
			>
				{#if errors}
					{#each errors as error}
						<p>{error}</p>
					{/each}
				{/if}	
			</Column>
		</Row>

		<Row padding>
			<Column xlg={1}>
				<Button 
					kind="gost" 
					disabled={skelliButton}
					icon={Erase32} 
					on:click={e=>{password='';email='';errors=[];}}
				>
					Clear
				</Button>
			</Column>
			<Column xlg={3}>
				<Button 
					class="float-right"
					skeleton={skelliButton}
					icon={ArrowRight32}
					on:click={(e)=>login(email,password)}
				>
					Login
				</Button>
			</Column>
		</Row>
	</Grid>
</FluidForm>

<style lang="scss" global>
  .bx--text-input {
    font-size: large;
  }
</style>

<script>
	import { onDestroy } from 'svelte'
  import auth from '../../helpers/auth.js'
	import { navigate  } from 'svelte-routing'
	import { createEventDispatcher } from "svelte"

	// Native Carbon Components
	import {
    Header,
		SkipToContent,
		Content,
		PasswordInput,
		Form,
		FluidForm,
		Button,
		ButtonSet,
		Grid,
		Row,
		Column,
		TextInput,
		Link,
	} from "carbon-components-svelte"
	import ArrowRight32 from "carbon-icons-svelte/lib/ArrowRight32"
	import Erase32 from "carbon-icons-svelte/lib/Erase32"

  const dispatch = createEventDispatcher()

	let authStore
	let unsubscribe = auth.subscribe(store => {
    	authStore = store
	})

	let email = ''
	let password = ''
	let loading = false
	let errors=[]
	$: isLoggedIn = authStore.loggedIn
	$: skelliButton = loading

	async function login(email, password) {
		loading = true
		await auth.login(email, password)
		if (isLoggedIn) {
			dispatch('loggedIn', {})
			loading = false
		} else {
			loading = false
			errors = [...errors, authStore.error ]
		}
	}
	
	onDestroy(() => {
    if (unsubscribe) {
      unsubscribe()
    }
	})
</script>